<template lang="pug">
div.nse-poster-preview.style-poet
	poster-background(
		:spec="spec"
		:selected-items="selectedItems"
	)

	star-map-preview(
		:spec="spec"
		:selected-items="selectedItems"
		:clip-path="clipPath"
		:dimensions="dimensions"
		:background-color="bgStarmap"
		:zoom-shape="false"
	)

	border-starmap-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
	)
		astronomer-border(:selectedItems="selectedItems")


	text-element-preview(
		v-if="spec.text_detail"
		:spec="spec.text_detail"
		:selected-items="selectedItems"
		:text-color-force="colorTexture"
		:font-family="selectedItems.detail_font"
	)
		div.text-content
			div(v-html="textTitle")
			div(v-html="textDateTime")
			div(v-html="textLocation")
			div(v-html="textCoordinate")

	text-element-preview(
		v-if="spec.text_saying"
		:spec="spec.text_saying"
		:selected-items="selectedItems"
		:text-color-force="colorTexture"
		:font-family="selectedItems.message_font"
	)
		div.text-content
			div(v-html="textSaying")


	border-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
		:border-color="colorTexture"
	)

	frame-physical-preview(
		:selected-items="selectedItems"
		:dimensions="dimensions"
	)
</template>


<script>
import {computed} from "vue";
import ParseSpecifications from "@/commons/ParseSpecifications";
import TextElementPreview from "@/preview/components/TextElement";
import TextParse from "@/commons/TextParse";
import StarMapPreview from "@/preview/components/StarMapPreview";
import PathSvg from "@/commons/PathSvg";
import {PreviewHelper} from "@/preview/PreviewHelper";
import AstronomerBorder from "@/preview/components/AstronomerBorder";

export default {
	name: "PoetStyle",
	components: {AstronomerBorder, StarMapPreview, TextElementPreview},
	props: {
		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		}
	},

	setup(props) {
		const spec = computed(() => {
			return ParseSpecifications.parse(props.selectedItems.poster_size, props.dimensions)
		});


		const {textColor, starMapColor, starMapColorHex} = PreviewHelper(props);
		const colorTexture = computed(() => {
			return textColor.value;
		});

		const borderColorLight = computed(() =>{
			return textColor.value;
		});
		const borderColorDark = computed(() =>{
			return starMapColor.value;
		});

		const svgTextColor = computed(() =>{
			return '#000';
		});

		const colors = computed(() => {
			if (starMapColorHex.value !== textColor.value) {
				return {
					bg: textColor.value,
					text_outside: textColor.value,
					line_outside: textColor.value,

					line_inside: starMapColorHex.value,
					text_inside: starMapColorHex.value,
				}
			} else {
				return {
					bg: textColor.value,
					text_outside: textColor.value,
					line_outside: textColor.value,
					text_inside: '#ffffff',
					line_inside: '#ffffff',
				}
			}

		})

		const {
			textSaying,
			textLocation,
			textDate,
			textCountry,
			textCity,
			textCoordinate,
			textTitle,
            textDateTime
		} = TextParse(props);

		const clipPath = PathSvg.circle(window.nse_app.star_map_width_mobile)

		const styleBG = computed(() => {
			return `background-color: #${bgStarmap.value}`
		});

		const borderStarmapImage = computed(() => {
			if (['#fff', '#ffffff'].indexOf(colorTexture.value) >= 0) {
				return window.nse_config.assets_url + "assets/image/astronomer/border-color.svg";
			} else {
				return window.nse_config.assets_url + "assets/image/astronomer/border.svg";
			}

		});

		const bgStarmap = computed(() => {
			return props.selectedItems.background_color ? props.selectedItems.background_color.value : ''
		});

		return {
			bgStarmap,
			spec,
			colorTexture,
			textSaying,
			textLocation,
			textCountry,
			textCity,
			textCoordinate,
			textTitle,
            textDateTime,
            clipPath,
			styleBG,
			borderStarmapImage,
			borderColorLight,
			borderColorDark,
			svgTextColor,
			colors,
		}
	}
}
</script>


